import { render, staticRenderFns } from "./ResultDetailComponent.vue?vue&type=template&id=7fd0c099"
import script from "./ResultDetailComponent.vue?vue&type=script&lang=js"
export * from "./ResultDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./ResultDetailComponent.vue?vue&type=style&index=0&id=7fd0c099&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports